






























































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { CaseDashboard, CaseDateFilter } from "@/store/modules/types";
import { filterOn } from "@/utils";
import InputPopover from "@/components/InputPopover.vue";
import SelectPopover from "@/components/SelectPopover.vue";
import DatePopover from "@/components/DatePopover.vue";
import DateRangePopover from "@/components/DateRangePopover.vue";
import PatientFilterPopover from "@/components/PatientFilterPopover.vue";
@Component({
  components: {
    InputPopover,
    SelectPopover,
    DatePopover,
    DateRangePopover,
    PatientFilterPopover,
  },
  computed: {
    ...mapState("cases", [
      "dashboard",
      "types",
      "activity",
      "riskLevels",
      "status",
      "users",
    ]),
  },
})
export default class CaseList extends Vue {
  dashboard!: CaseDashboard;
  get patientFilterOn() {
    return filterOn(this.dashboard.filter.patient);
  }
  setIdFilter(value: string) {
    this.$store.commit("cases/SET_ID_FILTER", value);
  }
  setPatientFilter(value: any) {
    this.$store.commit("cases/SET_PATIENT_FILTER", value);
  }
  setTypeFilter(value: number[]) {
    this.$store.commit("cases/SET_TYPE_FILTER", value);
  }
  setActivityFilter(value: number[]) {
    this.$store.commit("cases/SET_ACTIVITY_FILTER", value);
  }
  setRiskLevelFilter(value: string[]) {
    this.$store.commit("cases/SET_RISK_LEVEL_FILTER", value);
  }
  setStatusFilter(value: string[]) {
    this.$store.commit("cases/SET_STATUS_FILTER", value);
  }
  setReferralDateFilter(from, to) {
    const filter: CaseDateFilter = { from, to };
    this.$store.commit("cases/SET_REFERRAL_DATE_FILTER", filter);
  }
  setOwnerUserFilter(value: number[]) {
    this.$store.commit("cases/SET_OWNER_USER_FILTER", value);
  }
  setCreatedFilter(from, to) {
    const filter: CaseDateFilter = { from, to };
    this.$store.commit("cases/SET_CREATED_FILTER", filter);
  }
  setUpdatedFilter(from, to) {
    const filter: CaseDateFilter = { from, to };
    this.$store.commit("cases/SET_UPDATED_FILTER", filter);
  }
  setOrderBy(field: string) {
    this.$store.commit("cases/SET_ORDER_BY_FILTER", field);
  }
  get orderBy(): string {
    return this.dashboard.filter.orderBy;
  }
}
